import type { Maybe, Nullable } from "@/types/utils";

/** Trims string, returns null if empty */
export const trimToNull = (value: Nullable<string>): Nullable<string> =>
  value?.trim() || null;

/** Trims all string values in object (deep) */
export const trimStringValues = <T>(value: T): T => {
  if (typeof value === "string") {
    return value.trim() as T;
  }

  if (Array.isArray(value)) {
    return value.map(trimStringValues) as T;
  }

  if (value !== null && typeof value === "object") {
    return Object.entries(value).reduce(
      (acc, [key, val]) => ({
        ...acc,
        [key]: trimStringValues(val),
      }),
      {} as T,
    );
  }

  return value;
};

/** Checks if string is empty after trimming (handles null/undefined) */
export const isEmptyAfterTrim = (value: Maybe<Nullable<string>>): boolean =>
  !value?.trim();

/** Checks if any strings are empty after trimming */
export const anyEmptyAfterTrim = (
  ...values: Maybe<Nullable<string>>[]
): boolean => values.some(isEmptyAfterTrim);
